import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Box, Typography, Button } from "@mui/material";
import paths from "../../../Infrastructure/Router/paths";
    import { careersMessageModalSx } from './styles';
import { Loader } from "../Loader/loader";

const CareersMessageModal = ({ open, setOpen }) => {
  const navigate = useNavigate()
  const handleClose = () => setOpen(false);
  const { data, loading } = useSelector((state) => state.userData)
  if (loading) return <Loader />
  return (
    <Modal
      open={open} 
      disableScrollLock
      onClose={handleClose} 
      aria-labelledby="login-modal-title"
      aria-describedby="login-modal-description"
      sx={careersMessageModalSx.modal}
      BackdropProps={{
        sx: careersMessageModalSx.backdrop
      }}
    >
      <Box sx={careersMessageModalSx.box}>
        <Box onClick={handleClose} sx={careersMessageModalSx.closeIconBox}>
          <CloseIcon size={"small"} />
        </Box>

        <Typography textAlign={'center'} gutterBottom fontSize={20}>
          {data?.is_educator ? "Please create your desired course using the Dashboard"
            : "Must have an educator account to apply"}
        </Typography>
        <Box display={'flex'} justifyContent={'space-between'} gap={2}>

          {data?.is_educator && (
            <Button variant="contained" onClick={() => navigate(paths.dashboardPage.path)} fullWidth>
              Dashboard
            </Button>
          )}
          <Button
            variant="contained"
            sx={data?.is_educator ? careersMessageModalSx.educatorCloseButton : {}}
            onClick={handleClose}
            fullWidth
          >
            Close
          </Button>


        </Box>
      </Box>
    </Modal>
    
  );
};

export default CareersMessageModal;
